module.exports = __webpack_public_path__ + "img/1557912286.578108f3.jpg";